import Vue from 'vue'
import VueRouter, { isNavigationFailure, NavigationFailureType } from 'vue-router'
import Layout from '@/layouts/index.vue';
import { $getEntInitInfo, $getLoginUserInfo } from '@/utils/api'
import { getDonationPresence, parseDonationListTotal } from '@/api/donation'
import { scrollToTop } from '@/utils/scrollToTop'
import {
  isEntHomeReadyStatus,
  isEntPlatformMenuPath,
  isLegacyActivityEntryPath,
  parseHasActivity,
  persistEntInitSession,
  readHasActivity,
  resolveHomePath,
  resolveHomePathByFlags,
} from '@/utils/entStatus'
Vue.use(VueRouter);

// const IndexPage = () => import('@/views/indexPage/index.vue');
const LoginPage = () => import('@/views/login/index.vue');
// const AddAct = () => import('@/views/act/add/index.vue');
// const ActInit = () => import('@/views/act/add/init.vue');

export const pageList = [{
  path: '/',
  redirect: '/donation'
}, {
  path: '/login',
  name: 'login',
  meta: { title: '登录页', noCheckStatus: true },
  component: LoginPage,
}, {
  path: '/register',
  component: Layout,
  children: [
    {
      path: '',
      name: 'register',
      component: () => import('@/views/register/index.vue'),
      meta: { title: '企业入驻页' },
    },
    {
      path: 'agreement',
      name: 'agreement',
      component: () => import('@/views/register/agreement.vue'),
      meta: { title: '腾讯企业公益平台服务协议', noCheckStatus: true },
    },
  ],
}, {
  path: '/report',
  component: Layout,
  children: [
    {
      path: '',
      name: 'report',
      component: () => import('@/views/report/index.vue'),
      meta: { title: '向善记录' },
    },
  ],
}, {
  path: '/donation',
  component: Layout,
  children: [
    {
      path: '',
      name: 'donation',
      component: () => import('@/views/donation/index.vue'),
      meta: { title: '捐赠管理' },
    },
    {
      path: 'detail',
      name: 'donationDetail',
      component: () => import('@/views/donation/detail.vue'),
      meta: { title: '捐赠详情', keepOnQueryChange: true },
    },
  ],
}, {
  path: '/actList',
  component: Layout,
  children: [
    {
      path: '',
      name: 'actList',
      component: () => import('@/views/actList/index.vue'),
      meta: { title: '活动列表页' },
    },
    {
      path: 'info',
      name: 'actInfo',
      component: () => import('@/views/actList/info/index.vue'),
      meta: { title: '活动信息页' },
    }
  ],
}, {
  path: '/fundActivity',
  component: Layout,
  children: [
    {
      path: '',
      name: 'fundActivity',
      component: () => import('@/views/fundActivity/index.vue'),
      meta: { title: '公益金活动', keepOnQueryChange: true },
    },
    {
      path: 'create',
      redirect: '/fundActivity/create/step',
    },
    {
      path: 'create/:activityType',
      name: 'fundActivityCreate',
      component: () => import('@/views/fundActivity/create.vue'),
      meta: { title: '发起活动' },
    },
    {
      path: 'edit',
      name: 'fundActivityEdit',
      component: () => import('@/views/fundActivity/edit.vue'),
      meta: { title: '编辑捐步活动' },
    },
    {
      path: 'info',
      name: 'fundActivityInfo',
      component: () => import('@/views/fundActivity/info.vue'),
      meta: { title: '活动详情' },
    },
  ],
}, {
  path: '/entInfo',
  component: Layout,
  children: [
    {
      path: '',
      name: 'entInfo',
      component: () => import('@/views/settings/index.vue'),
      meta: { title: '基础设置', keepOnQueryChange: true },
    },
    {
      // 企业认证改为基础设置页弹窗，旧链接带参数跳回并直接打开
      path: 'apply',
      name: 'entCertApply',
      redirect: { path: '/entInfo', query: { cert: 'apply' } },
    },
  ],
}, {
  path: '/member',
  component: Layout,
  children: [
    {
      path: '',
      name: 'member',
      redirect: { path: '/entInfo', query: { tab: 'member' } },
    },
    {
      path: 'detail',
      name: 'memberDetail',
      component: () => import('@/views/member/detail.vue'),
      meta: { title: '成员详情' },
    },
  ],
}, {
  path: '/exportList',
  component: Layout,
  children: [
    {
      path: '',
      name: 'exportList',
      component: () => import('@/views/exportList/index.vue'),
      meta: { title: '电子凭证下载页' },
    },
  ],
},
{
  path: '/act/init',  // 处理 index.html 的访问
  name: 'act_init',
  component: Layout,
  children: [
    {
      path: '',
      name: 'act_init',
      component: () => import('@/views/act/add/init.vue'),
      meta: { title: '初始化活动' },
    },
  ],
},
{
  path: '/act/add',  // 处理 index.html 的访问
  component: Layout,
  children: [
    {
      path: '',
      name: 'act_add',
      component: () => import('@/views/act/add/index.vue'),
      meta: { title: '新增活动' },
    },
  ],
},
{
  path: '/act/rechargeinit',
  component: Layout,
  children: [
    {
      path: '',
      name: 'act_rechargeinit',
      component: () => import('@/views/act/recharge/init.vue'),
      meta: { title: '资金充值' },
    },
  ],
},
{
  path: '/act/recharge',
  component: Layout,
  children: [
    {
      path: '',
      name: 'act_recharge',
      component: () => import('@/views/act/recharge/index.vue'),
      meta: { title: '资金充值' },
    },
  ],
},
{
  path: '/act/authinit',
  component: Layout,
  children: [
    {
      path: '',
      name: 'act_authinit',
      component: () => import('@/views/act/auth/init.vue'),
      meta: { title: '授权和冻结活动资金' },
    },
  ],
},
{
  path: '/act/auth',
  component: Layout,
  children: [
    {
      path: '',
      name: 'act_auth',
      component: () => import('@/views/act/auth/index.vue'),
      meta: { title: '授权和冻结活动资金' },
    },
  ],
},
]
const router = new VueRouter({
  mode: 'hash',
  routes: pageList
});
/** 接口不可用（网关未配路由、服务未发布等），此类错误不应把用户挡在入驻流程外 */
const ROUTE_NOT_FOUND_CODE = 15150003;

/**
 * 账号是否已完善个人信息（姓名 + 手机号）。
 * 扫码登录后若跳过了「填写个人信息」这一步，账号里没有姓名手机号，
 * 入驻页的联系人无从回填，此时不允许进入入驻流程。
 * 仅在接口不可用时按「已完善」放行，其余异常一律按未完善处理。
 */
async function isUserProfileCompleted() {
  try {
    const user = await $getLoginUserInfo(undefined, {
      skipNoEntRedirect: true,
      hideErrorMessage: true,
    });
    return !!(user && user.user_name && user.user_phone);
  } catch (err) {
    // 网关未配置该路由时放行，避免未发布期间整条入驻链路不可用
    if (Number(err && err.code) === ROUTE_NOT_FOUND_CODE) {
      console.warn('GetLoginUserInfo 未就绪，跳过个人信息校验', err && err.msg);
      return true;
    }
    return false;
  }
}

function ignoreNavFailure(err) {
  if (
    isNavigationFailure(err, NavigationFailureType.duplicated) ||
    isNavigationFailure(err, NavigationFailureType.redirected) ||
    isNavigationFailure(err, NavigationFailureType.cancelled) ||
    isNavigationFailure(err, NavigationFailureType.aborted)
  ) {
    return err;
  }
  throw err;
}
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(ignoreNavFailure);
};
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(ignoreNavFailure);
};

// 全局前置守卫
let isChecked = false; // 防止死循环
router.beforeEach(async (to, from, next) => {
  // 手动滚动到顶部，同一页面内只改 query（如切 tab）时保持当前滚动位置
  if (!(to.meta.keepOnQueryChange && from.path === to.path)) {
    scrollToTop();
  }
  // 可选：只在需要校验的页面做判断
  if (to.meta.noCheckStatus) return next()
  // 防止死循环
  if (isChecked) {
    isChecked = false;
    return next();
  }
  // nolocate：入驻流程中的页面跳转，跳过路由守卫的状态检查
  if (sessionStorage.getItem('nolocate')) {
    sessionStorage.removeItem('nolocate');
    return next();
  }
  // 平台页互切不重复拉 GetEntInitInfo；捐赠 overview/list 由侧栏在登录、切企业后重查
  if (from.matched.length && isEntPlatformMenuPath(from.path) && isEntPlatformMenuPath(to.path)) {
    return next();
  }

  try {
    // 入驻页：未选企业登录（32240002）是入驻前的合法初始态，交由本守卫放行；
    // 但登录态失效（110027）仍要由拦截器送回登录页，故不能用 skipAuthRedirect
    const initOptions = to.path === '/register'
      ? { skipNoEntRedirect: true, hideErrorMessage: true }
      : undefined;
    if (to.path === '/register' && !(await isUserProfileCompleted())) {
      // 扫码后跳过了「填写个人信息」：账号无姓名手机号，入驻页联系人无从回填，
      // 回到登录页补全该步骤。/login 带 noCheckStatus 会被守卫直接放行，
      // 不会死循环，因此不能置 isChecked（否则会让下一次导航少做一次状态校验）
      return next({ path: '/login', query: { view: 'register', step: '2' } });
    }
    const res = await $getEntInitInfo(undefined, initOptions); // 1-已提交企业, 2-已提交活动, 3-已提交冻结(待校验冻结状态), 4-已冻结成功, 5-已提交活动审核, 6-活动审核成功, 11-企业审核不通过, 12-活动审核不通过, 13-冻结失败
    // 0 新用户入驻，/register
    // 1 已提交企业，进入活动页 /act/init
    // 2 已提交活动，进入充值页 /act/recharge
    // 3、4、5 已提交冻结，进入授权页 /act/auth
    // 6 活动审核成功 进入活动列表页 /actList
    // 11 企业审核驳回 /register
    // 12 活动审核驳回 /act/init
    // 13 冻结失败，进入授权页 /act/auth
    persistEntInitSession(res);
    // 有无捐赠不读 session；侧栏登录/切企业后自己重查 overview + list
    // 老入驻向导。30–33 仍拦截这些页，但 /act/add、/act/recharge、/act/auth 是平台内新建/编辑活动，要放行
    const isOnboardingPath = [
      '/register',
      '/act/init',
      '/act/rechargeinit',
      '/act/authinit',
    ].some(path => to.path === path || to.path.startsWith(`${path}/`));
    // 0 / 11 先于平台页短路，避免已选企业后仍进捐赠页
    if ((res.status === 0 || res.status === 11) && to.path !== '/register') {
      isChecked = true;
      return next('/register');
    }
    // 无存量 B2B 活动时，活动管理 / 数据导出入口不可进
    if (isLegacyActivityEntryPath(to.path) && !parseHasActivity(res)) {
      isChecked = true;
      return next(resolveHomePath());
    }
    // 登录或直达捐赠首页：没有捐赠记录时不落在 /donation
    if (to.path === '/donation') {
      let hasDonation = false;
      try {
        const list = await getDonationPresence();
        hasDonation = parseDonationListTotal(list) > 0;
      } catch (error) {
        hasDonation = false;
      }
      if (!hasDonation) {
        const dest = resolveHomePathByFlags(false, parseHasActivity(res));
        if (dest !== to.path) {
          isChecked = true;
          return next(dest);
        }
      }
    }
    // 侧栏平台页（捐赠/活动/企业信息/成员/导出）互切，不再踢去注册或活动入驻
    if (isEntPlatformMenuPath(to.path)) {
      return next();
    }
    if (isEntHomeReadyStatus(res.status)) {
      if (isOnboardingPath) {
        isChecked = true;
        return next(resolveHomePath());
      }
      return next();
    } else if ((res.status === 1 || res.status === 12) && to.path !== '/act/init') {
      isChecked = true;
      if (res.activity_info.activity_no) return next(`/act/init?actno=${res.activity_info.activity_no}`)
      else return next(`/act/init`);
    } else if (res.status === 2 && to.path !== '/act/rechargeinit') {
      return next(`/act/rechargeinit?actno=${res.activity_info.activity_no}`);
    } else if ((res.status === 3 || res.status === 4 || res.status === 5 || res.status === 13) && to.path !== '/act/authinit') {
      return next(`/act/authinit?actno=${res.activity_info.activity_no}`);
      // } else if (res.status === 6 && to.path !== '/actList') {
      //   return next(`/actList`);
    } else {
      // 其他状态处理
      return next();
    }
  } catch (err) {
    if (isLegacyActivityEntryPath(to.path) && !readHasActivity()) {
      return next(resolveHomePath());
    }
    return next();
  }
});

export default router;
